import React from "react";
import Typical from "react-typical";
import Particles from "react-particles-js";
import "./FirstSection.css";
import photo from "./p1.png";
import Fade from "react-reveal/Fade";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileDownload } from "@fortawesome/free-solid-svg-icons";

const FirstSection = () => {
  return (
    <div
      style={{ background: "#242020", position: "relative" }}
      className="firstSec"
    >
      <div
        style={{ position: "absolute", top: "20%", left: "10%", right: "10%" }}
      >
        <div className="row">
          <div className="col-md-6 col-sm-12 text-white">
            <Fade left>
              <h1 style={{ marginTop: "70px" }}>
                Hi,I'm <span style={{ color: "#df5c04" }}>Sourav</span>
              </h1>
              <h2>
                {" "}
                I am a{" "}
                <Typical
                  className="style"
                  steps={[
                    "JavaScript Developer",
                    1000,
                    "React Developer",
                    1000,
                    "MERN Stack Developer",
                    1000,
                  ]}
                  loop={Infinity}
                  wrapper="b"
                />
              </h2>
              <p>
                A self-motivated and enthusiastic web developer with a deep
                interest in JavaScript To gain confidence and fame using my
                potential in the field of web development and express my
                innovative creative skills for self and company growth. I always
                like to learn new things and have experience with new stuff.
              </p>
              <button className="button">
                <FontAwesomeIcon icon={faFileDownload} />
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://drive.google.com/file/d/151VkM37Vyxy3blRi_Q-JJ6bAXcyN-tx4/view"
                  style={{ textDecoration: "none", color: "whitesmoke" }}
                >
                  <span style={{ marginLeft: "5px" }}>Resume </span>
                </a>
              </button>
            </Fade>
          </div>

          <div className="col-md-6 col-sm-12 text-white">
            <Fade right>
              <img
                src={photo}
                alt=""
                width="90%"
                height="400rem"
                className="logo-1"
              />
            </Fade>
          </div>
        </div>
      </div>

      <Particles
        params={{
          particles: {
            number: {
              value: 53,
              density: {
                enable: true,
                value_area: 800,
              },
            },
            color: {
              value: "#ffffff",
            },
            shape: {
              type: "circle",
              stroke: {
                width: 0,
                color: "#000000",
              },
              polygon: {
                nb_sides: 5,
              },
              image: {
                src: "img/github.svg",
                width: 100,
                height: "auto",
              },
            },
            opacity: {
              value: 0.5,
              random: false,
              anim: {
                enable: false,
                speed: 1,
                opacity_min: 0.1,
                sync: false,
              },
            },
            size: {
              value: 3,
              random: true,
              anim: {
                enable: false,
                speed: 40,
                size_min: 0.1,
                sync: false,
              },
            },
            line_linked: {
              enable: true,
              distance: 150,
              color: "#ffffff",
              opacity: 0.4,
              width: 1,
            },
            move: {
              enable: true,
              speed: 6,
              direction: "none",
              random: false,
              straight: false,
              out_mode: "out",
              bounce: false,
              attract: {
                enable: false,
                rotateX: 600,
                rotateY: 1200,
              },
            },
          },
          interactivity: {
            detect_on: "canvas",
            events: {
              onhover: {
                enable: true,
                mode: "repulse",
              },
              onclick: {
                enable: true,
                mode: "push",
              },
              resize: true,
            },
            modes: {
              grab: {
                distance: 400,
                line_linked: {
                  opacity: 1,
                },
              },
              bubble: {
                distance: 400,
                size: 40,
                duration: 2,
                opacity: 8,
                speed: 3,
              },
              repulse: {
                distance: 200,
                duration: 0.4,
              },
              push: {
                particles_nb: 4,
              },
              remove: {
                particles_nb: 2,
              },
            },
          },
          retina_detect: true,
        }}
      />
    </div>
  );
};

export default FirstSection;
